<template>
    <div>
        <BackButton/>

        <h2>Zulassungskriterien überprüfen</h2>

        <b-alert variant="success" :show="fullfillsAcceptanceCriterias && checkButtonWasClicked">
            <font-awesome-icon :icon="['fas', 'user-check']"/>
            Glückwünsch! Sie erfüllen die Zulassungskriterien.
        </b-alert>
        <b-alert variant="danger" :show="!fullfillsAcceptanceCriterias && checkButtonWasClicked">
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']"/>
            Sie erfüllen die Zulassungskriterien leider nicht. Wenn Sie trotzdem Interesse haben, nehmen Sie bitte
            <router-link to="/kontakt">Kontakt mit der Studiengangleitung auf.</router-link>
        </b-alert>
        <b-alert variant="warning" :show="!form.hasPreCourse && checkButtonWasClicked">
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']"/>
            Sie müssen noch folgenden Vorkurs besuchen: Wissenschaftliches Arbeiten
        </b-alert>

        <b-form @submit="onSubmit">
            <b-form-group class="zhaw-form-group"
                          label="Welchen der folgenden Abschlüsse besitzen Sie? *"
                          v-b-tooltip.hover
                          title="Tooltip Content"
                          :disabled="checkButtonWasClicked">
                <b-form-radio-group v-model="form.graduation" stacked required>
                    <b-form-radio name="education" :value="form.graduationValues.higherGraduation">{{ form.graduationValues.higherGraduation }}</b-form-radio>
                    <b-form-radio name="education" :value="form.graduationValues.lowerGraduation">{{ form.graduationValues.lowerGraduation }}</b-form-radio>
                    <b-form-radio name="education" :value="form.graduationValues.noGraduation">{{ form.graduationValues.noGraduation }}</b-form-radio>
                </b-form-radio-group>
            </b-form-group>

            <b-form-group class="zhaw-form-group"
                          label="Haben Sie den Vorkurs 'Wissenschaftliches Arbeiten' besucht? *"
                          v-b-tooltip.hover
                          title="Tooltip Content"
                          :disabled="checkButtonWasClicked">
                <b-form-radio-group v-model="form.hasPreCourse" stacked required>
                    <b-form-radio name="pre-course" :value="true">Ja</b-form-radio>
                    <b-form-radio name="pre-course" :value="false">Nein</b-form-radio>
                </b-form-radio-group>
            </b-form-group>

            <b-form-group v-if="form.graduation === form.graduationValues.higherGraduation"
                          class="zhaw-form-group"
                          label="Haben Sie Berufserfahrung von mindestens 3 Jahren? *"
                          v-b-tooltip.hover
                          title="Tooltip Content"
                          :disabled="checkButtonWasClicked">
                <b-form-radio-group v-model="form.professionalExperience" stacked required>
                    <b-form-radio name="work-experience-3years" :value="true">Ja</b-form-radio>
                    <b-form-radio name="work-experience-3years" :value="false">Nein</b-form-radio>
                </b-form-radio-group>
            </b-form-group>

            <b-form-group v-if="form.graduation === form.graduationValues.lowerGraduation || form.graduation === form.graduationValues.noGraduation"
                          class="zhaw-form-group"
                          label="Haben Sie Berufserfahrung von mindestens 5 Jahren? *"
                          v-b-tooltip.hover
                          title="Tooltip Content"
                          required
                          :disabled="checkButtonWasClicked">
                <b-form-radio-group v-model="form.professionalExperience" stacked required>
                    <b-form-radio name="work-experience-5years" :value="true">Ja</b-form-radio>
                    <b-form-radio name="work-experience-5years" :value="false">Nein</b-form-radio>
                </b-form-radio-group>
            </b-form-group>

            <CancelButton router-link="/start" />
            <b-button @click="checkButtonWasClicked = false">
                <font-awesome-icon :icon="['fas', 'edit']"/>
                Formular anpassen
            </b-button>
            <b-button v-if="checkButtonWasClicked" to="/initiale-angaben" variant="primary">
                <font-awesome-icon :icon="['fas', 'chevron-right']"/>
                Zur Beratung
            </b-button>
            <b-button v-if="!checkButtonWasClicked" to="/initiale-angaben">
                <font-awesome-icon :icon="['fas', 'chevron-right']"/>
                Zur Beratung
            </b-button>
            <b-button v-if="!checkButtonWasClicked" type="submit" variant="primary">
                <font-awesome-icon :icon="['fas', 'check']"/>
                Zulassung überprüfen
            </b-button>
        </b-form>


    </div>
</template>

<script>
    import BackButton from "./helper-components/BackButton";
    import CancelButton from "./helper-components/CancelButton";
    import {herokuApi} from "../api/axiosConfig";

    export default {
        name: "AcceptanceCriteria",
        components: {CancelButton, BackButton},
        data() {
            return {
                form: {
                    graduation: null,
                    graduationValues: {
                        higherGraduation: 'FH/Uni',
                        lowerGraduation: 'HF/eidg. Diplom',
                        noGraduation: 'Keiner der genannten Abschlüsse'
                    },
                    professionalExperience: null,
                    hasPreCourse: null
                },
                fullfillsAcceptanceCriterias: null,
                checkButtonWasClicked: false,
                axiosErrors: [],
                axiosHasError: false,
                axiosLoading: false
            }
        },
        computed: {
            /* Workaround for the Form-Validation, which doesn't work yet (Bootstrap Vue) */
          hasIncompleteForm: function() {
             return (this.form.graduation === null) || (this.form.hasPreCourse === null) || (this.form.professionalExperience === null);
          }
        },
        methods: {
            /* Sets the correct Acceptance-Property for the message in the UI
            and sends the selected Data via the API to the Back-End */
            checkAcceptanceCriterias: function () {
                this.checkButtonWasClicked = true;
                this.saveSelectedData();
                if (this.form.graduation === this.form.graduationValues.higherGraduation && this.form.professionalExperience === true) {
                    return this.fullfillsAcceptanceCriterias = true
                } else if (this.form.graduation === this.form.graduationValues.lowerGraduation && this.form.professionalExperience === true) {
                    return this.fullfillsAcceptanceCriterias = true
                } else {
                    return this.fullfillsAcceptanceCriterias = false
                }
            },
            saveSelectedData: function () {
                herokuApi
                    .post('/recommender/updateQualification', {
                        graduation: this.form.graduation,
                        professionalExperience: this.form.professionalExperience,
                        preCourse: this.form.hasPreCourse
                    })
                    .then(() => this.axiosLoading = true)
                    .catch(error => {
                        this.axiosErrors.push(error);
                        this.axiosHasError = true
                    })
                    .finally(() => this.axiosLoading = false)
            },
            onSubmit(evt) {
                evt.preventDefault();
                this.checkAcceptanceCriterias();
            }
        }
    }
</script>

<style scoped>
    .zhaw-form-group {
        margin-top: 2rem;
    }
</style>